import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

const WELCOME_MESSAGES = [
  '今日は何をしましょうか？',
  'どんな出張の予定がありますか？',
  '出張の手配をお手伝いします',
  'どちらへ行かれますか？',
  '次の出張はいつですか？',
  'ご出張のご予定をお聞かせください',
  '出張についてお聞かせください'
];

const getStyles = (theme: AITTheme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  title: {
    fontSize: '24px',
    fontWeight: 600 as const,
    color: theme.textColor,
    margin: 0
  }
});

const NewChatWelcome: React.FC = () => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  const message = useMemo(() => WELCOME_MESSAGES[Math.floor(Math.random() * WELCOME_MESSAGES.length)], []);

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>{message}</h1>
    </div>
  );
};

export default NewChatWelcome;
